import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Portal from './pages/portal/Portal';
import TradingHome from './pages/trading/Home';
import TradingCareers from './pages/trading/Careers';
import ConsultingHome from './pages/consulting/ConsultingHome';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Portal />} />
          <Route path="/trading/*" element={
            <>
              <Navbar section="trading" />
              <Routes>
                <Route path="/" element={<TradingHome />} />
                <Route path="/careers" element={<TradingCareers />} />
              </Routes>
              <Footer />
            </>
          } />
          <Route path="/consulting/*" element={
            <>
              <Navbar section="consulting" />
              <Routes>
                <Route path="/" element={<ConsultingHome />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
